import { Text } from '@chakra-ui/react';
export const StatusLine = (props: { title: string; status: string }) => {
  return (
    <>
      <Text fontWeight={'bold'} fontSize={'xs'}>
        {props.title}:
      </Text>
      <Text fontSize={'xs'} truncate>
        {props.status}
      </Text>
    </>
  );
};
